/*!
 * devextreme-react
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */

"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const element_1 = require("./configuration/react/element");
const use_option_scanning_1 = require("./use-option-scanning");
const contexts_1 = require("./contexts");
const NestedOption = function NestedOption(props) {
    const { children } = props;
    const { elementDescriptor, ...restProps } = props;
    if (!elementDescriptor) {
        return null;
    }
    const { parentExpectedChildren, onChildOptionsReady: triggerParentOptionsReady, getOptionComponentKey, treeUpdateToken, } = (0, react_1.useContext)(contexts_1.NestedOptionContext);
    const { discoveryRendering } = (0, react_1.useContext)(contexts_1.TemplateDiscoveryContext);
    const [optionComponentKey] = (0, react_1.useState)(getOptionComponentKey());
    const optionElement = (0, element_1.getOptionInfo)(elementDescriptor, restProps, parentExpectedChildren);
    const templateContainer = (0, react_1.useMemo)(() => document.createElement('div'), []);
    const mainContainer = (0, react_1.useMemo)(() => document.createElement('div'), []);
    const [config, context,] = (0, use_option_scanning_1.useOptionScanning)(optionElement, children, templateContainer, treeUpdateToken);
    (0, react_1.useLayoutEffect)(() => {
        if (!discoveryRendering) {
            triggerParentOptionsReady(config, optionElement.descriptor, treeUpdateToken, optionComponentKey);
        }
    }, [treeUpdateToken]);
    return discoveryRendering ? null : React.createElement(React.Fragment, {}, (0, react_dom_1.createPortal)(React.createElement(contexts_1.TemplateDiscoveryContext.Provider, {
        value: {
            discoveryRendering: true,
        },
    }, children), templateContainer), (0, react_dom_1.createPortal)(React.createElement(contexts_1.NestedOptionContext.Provider, {
        value: context,
    }, children), mainContainer));
};
exports.default = NestedOption;
